import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-datos-usuario-header',
  templateUrl: './datos-usuario-header.component.html',
  styleUrls: ['./datos-usuario-header.component.scss']
})
export class DatosUsuarioHeaderComponent implements OnInit {
  @Input() nro_sumininstro: string = '';
  @Input() razonsocialrrll: string = '';
  @Input() nombres: string = '';
  @Input() apellidos: string = '';
  @Input() paterno: string = '';
  @Input() materno: string = '';
  @Input() tipo_documento: string = '';
  @Input() nro_documento: string = '';
  @Input() isJuridico: boolean = false;
  @Input() disabledInput: boolean = true;
  @Output() outnombres = new EventEmitter();
  @Output() outpaterno = new EventEmitter();
  @Output() outmaterno = new EventEmitter();

  labelname: string;
  labelapel: string;
  labelrsoc: string;

  


  constructor(
    private globals: Globals
  ) {
    
  }

  ngOnInit() {
    console.log('............... '+this.globals.isJuridico)
    if (this.globals.isJuridico) {
      this.labelJuridico();
    }else {
      this.labelNatural();
    }
  }

  labelJuridico() {
    this.labelname = 'Nombres RRLL';
    this.labelapel = 'Apellidos RRLL';
    this.labelrsoc = 'Razón Social';
  }

  labelNatural() {
    this.labelname = 'Nombres';
    this.labelapel = 'Apellidos';
    this.labelrsoc = 'Razón Social';
  }

  emitNombre(e) {
    this.outnombres.emit(e);
  }

  emitPaterno(e) {
    this.outpaterno.emit(e);
  }

  emitMaterno(e) {
    this.outmaterno.emit(e);
  }
}
